import { AfterViewInit, Component, ElementRef, HostListener, OnChanges, OnInit, Renderer2, SimpleChanges, ViewChild, viewChild } from '@angular/core';
import GlobalService from 'src/app/services/global.service';
import { SeoService } from 'src/app/services/seo.service';
import { fadeInAnimation } from 'src/app/share/animations/animation';
import { organs } from 'src/app/share/models/bussiness_fields';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  animations:[fadeInAnimation]
})
export class HomeComponent implements OnInit,AfterViewInit{
  @ViewChild('waveDiv') waveDiv !:ElementRef 
  loading = true
  organs = organs
  constructor(
    private seoService:SeoService,
    private globalService:GlobalService,
    private renderer: Renderer2
  ){}
  ngOnInit(): void {
    this.updateMargin()
    this.seoService.setTitle('آفرینه | زندگی به سبک نوآفرینی');
    this.seoService.setDescription('آفرینه | زندگی به سبک نوآفرینی');
    this.seoService.setKeywords('آفرینه،نانو،نوآوری،نوآفرینی،کسب و کار،رشدیما،کارگاه،افرینه،فرینه،کسب،کار،نوآرینو،آیتی')
    window.scroll({
      top:0,
      left:0,
      behavior:'auto'
    })
  }
  ngAfterViewInit() {
    this.updateMargin(); // Call once when the view initializes
  }
  @HostListener('window:resize')
  onResize() {
    this.updateMargin(); // Call on window resize
  }
  private updateMargin() {
    setTimeout(() => {
      if (this.waveDiv) {
        const height = this.waveDiv.nativeElement.getBoundingClientRect().height;
        console.log(height); // Log height to check

        // this.renderer.setStyle(this.waveDiv.nativeElement, 'margin-top', `-${height+10}px`);
      }
    }, 0);
  }
  toggleSidebar() {
    const sidebar = document.getElementById('sidebar');
    if (sidebar) {
      sidebar.classList.toggle('translate-x-full');
    }
  }
  openNav() {
    const sidenav = document.getElementById("mySidenav");
    if (sidenav) {
      sidenav.style.width = "250px";
    }
  }
  closeNav() {
    const sidenav = document.getElementById("mySidenav");
    if (sidenav) {
      sidenav.style.width = "0";
    }
  }
  ngOnDestroy(): void {
    window.scroll({
      top:0,
      left:0,
      behavior:'smooth'
    })
  }
  islandscapeInMobile(){
    return this.globalService.isLAndScape() && window.innerHeight<=768
  }
  isMobileView(){
    return window.innerHeight<= 768
  }
}
